import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { useAccountFormContext } from '../../context/useAccountFormContext';
import { useYearAgeOptionsWithRightLabel } from './useYearAgeOptionsWithRightLabel';

export const ContributionStartYearSelect = () => {
  const formBag = useFormContext();

  const {
    options: { ContributionStartYearOptions },
  } = useAccountFormContext();

  const options = useYearAgeOptionsWithRightLabel({ options: ContributionStartYearOptions });

  return (
    <Controller
      control={formBag.control}
      name="bankAccount.ContributionStartYear"
      render={({ field: { value, onChange } }) => {
        return (
          <Select
            isPortal
            value={value}
            options={options}
            onChange={contribution => onChange(contribution)}
            label="Contribution Start Year"
          />
        );
      }}
    />
  );
};
